$('.footer__drop .footer__drop-head').on('click', function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('footer__drop_open');
    $(this).siblings('.footer__drop-body').slideToggle();
})

$('.footer').on('click', '.footer__col-title', function (e) {
    e.preventDefault();
    if (window.innerWidth > 575) return;

    $(this).toggleClass('is-open');
    $(this).siblings('.footer__col-wp').slideToggle();
})

window.addEventListener('resize', e => {
    if (window.innerWidth > 575) {
        $('.footer__col-title').removeClass('is-open');
        $('.footer__col-wp').css('display', '');
    }
})